module.exports = __webpack_public_path__ + "static/media/twitter.7cc87e4c.svg";